/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { DtpTab, DtpContentContainer, DtpTabGroup } from 'dtp-react-components';
import DadosRemuneracaoControl from './DadosRemuneracaoControl';
import {
  Grid,
  Input,
} from '../../../components/index';
import * as listUtils from '../../../utils/listsSelect';
import ModalAlerta from '../../requerimentos/ModalAlerta';
import {
  msgConfirmacaoCtc,
} from '../../../utils/constants';
import { trataMensagensErro } from '../../../utils/requests';

/* Organiza a lista de remunerações */
class RemuneracaoControl extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
  }

  textoDestaque = texto => {
    return (
      <React.Fragment>
        <span style={{
          zIndex: '1',
          background: 'none',
          height: '5.9rem',
          position: 'static',
          top: '1.6rem',
          display: 'block',
          width: '100%',
          fontSize: '1.6rem',
          marginBottom: '1rem',
          border: '0',
          borderBottom: '0.1rem solid #b7c4cb',
          backgroundColor: '#ffffff',
          padding: '24px 0px 8px 0px',
          // color: '#78909c',
          color: '#03a9f4',
          }}
        >
          {texto}
        </span>
      </React.Fragment>
    );
}

  getInitialState = () => ({
    idTabAtiva: null,
    tabAtiva: false,
    valorPreenchimentoAutomatico: null,
    idTabSelecionada: null,
    listaTabsDisponiveis: [],
    listaCompetenciasPorAno: [],
    showModalAlerta: false,
    showModalAlertaValoresDiferentes: false,
    showModalAlertaLimpezaAutomatica: false,
    houveAlteracaoDeMoedaNoPeriodo: false,
    quantidadeAnosPorTabs: 8,
    anoEscolhido: null,
    valorRemuneracaoAlterado: null,
  });

  componentDidMount() {
    // if (this.state.listaTabsDisponiveis.length === 0 ) {
    //   this.gerarListaTabsDisponiveisPreenchimentoAutomatico();
    // }
    if (this.state.listaCompetenciasPorAno.length === 0 ) {
      this.gerarListaCompetenciasPorAno();
    }
  }
  
  gerarListaCompetenciasPorAno = () => {
    let retorno = [];
    this.props.remuneracoesAtividade.moedasCompetencia.forEach((item) => {
      retorno.push(`${item.competencia.substring(0, 2)}-${item.ano}`);
    });
    this.setState({
      listaCompetenciasPorAno: retorno,
    });
  }

  montarTituloTab = (listaAnos, indiceInicio, indiceFim) => {
    let titulo = '';
    if (Number(indiceInicio - indiceFim) === 0) {
      titulo = listaAnos[indiceFim];
    } else {
      if (listaAnos.length === 1) {
        titulo = listaAnos[indiceInicio];
      } else {
        let fim = 0;
        if (listaAnos.length < indiceFim) {
          fim = (listaAnos.length -1);
          titulo = `${listaAnos[indiceInicio]}...${listaAnos[fim]}`;
        } else {
          if (listaAnos.length === indiceFim) {
            fim = (listaAnos.length -1);
            titulo = `${listaAnos[indiceInicio]}...${listaAnos[fim]}`;
          } else {
            fim = listaAnos[indiceFim];
            titulo = `${listaAnos[indiceInicio]}...${listaAnos[indiceFim]}`;
          }
        }
      }
    }
    return titulo;
  }

  montarIdTab = (listaAnos, indiceInicio, indiceFim) => {
    let fim = 0;
    let id = null;
    if (listaAnos.length === 1) {
      id = `${listaAnos[indiceInicio]}-${listaAnos[indiceInicio]}`;
    } else {
      if (listaAnos.length < indiceFim) {
        fim = (listaAnos.length -1);
        id = `${listaAnos[indiceInicio]}-${listaAnos[fim]}`;
      } else {
        if (listaAnos.length === indiceFim) {
          fim = (listaAnos.length -1);
          id = `${listaAnos[indiceInicio]}-${listaAnos[fim]}`;
        } else {
          fim = listaAnos[indiceFim];
          id = `${listaAnos[indiceInicio]}-${listaAnos[indiceFim]}`;
        }
      }
    }
    return id;
  }

  handleChange = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
    });
  }

  handleChangeQuantidadeAnosPorAbas = (changeObj, name) => {
    this.setState({
      [name]: changeObj.value,
  }, () => this.montarTabsDinamicas());
  }      

  limparCaixaValorAutomatico = () => {
    this.setState({
      valorPreenchimentoAutomatico: '',
    });
  }

  marcarTabAtiva = (changeObj, name) => {
    this.setState({
      [name]: changeObj,
    }, this.limparCaixaValorAutomatico());
  }

  criarTab = (titulo, idTab, ativa) => (
    <DtpTab
      id={idTab}
      title={titulo}
      className={ativa ? "active" : ''}
      onClick={e => this.marcarTabAtiva(idTab, 'idTabSelecionada')}
    >
      <DadosRemuneracaoControl
        intervalo={idTab}
        tabAtiva={ativa}
        remuneracoesAtividade={this.props.remuneracoesAtividade}
        handleChange={this.props.handleChange}
        atualizarListaRemuneracao={this.props.atualizarListaRemuneracao}
        remuneracoesPreenchidas={this.props.remuneracoesPreenchidas}
        listaCompetenciasPorAno={this.state.listaCompetenciasPorAno}
        desabilitarCampos={this.props.desabilitarCampos}        
        preencherValoresAutomaticamente={this.preencherValoresAutomaticamente}
        alertarPreenchimentoAutomatico={this.alertarPreenchimentoAutomatico}
        limparValoresAutomaticamente={this.limparValoresAutomaticamente}
        alertarLimpezaAutomatica={this.alertarLimpezaAutomatica}
        operacaoRemuneracao={this.props.operacaoRemuneracao}
        anoEscolhido={this.props.anoEscolhido}
        verificarHabilitacaoBotaoLimpeza={this.verificarHabilitacaoBotaoLimpeza}
        acao={this.props.acao}
      />
    </DtpTab>
  )

  montarObjeto = (idTab, titulo) => {
    return {value: idTab, label: titulo};
  }

  popularListaTabsDisponiveis = (listaTabsDisponiveis, objtab) => {
    let colecao = listaTabsDisponiveis;
    colecao.push(objtab);
    return colecao;
  }

  alertarPreenchimentoAutomatico = (ano) => {
    this.setState({
      alertas: [msgConfirmacaoCtc.preencherValoresAutomaticamente],
      showModalAlerta: !this.state.showModalAlerta,
      anoEscolhido: ano,
    });
  }

  alertarLimpezaAutomatica = (ano) => {
    this.setState({
      alertas: [msgConfirmacaoCtc.limparValoresAutomaticamente],
      showModalAlertaLimpezaAutomatica: !this.state.showModalAlertaLimpezaAutomatica,
      anoEscolhido: ano,
    });
  }

  verificarExistenciaDeMudancaDeMoedaNaCompetencia = () => {
    const { remuneracoesPreenchidas }  = { ...this.props };
    const { anoEscolhido }  = { ...this.state };
    let houveAlteracaoDeMoedaNoPeriodo = false;
    let novoValorRemuneracao = null;
    let aux = [];
    
    for (var i = 0; i < remuneracoesPreenchidas.length; i++) {
      if (anoEscolhido === (Number(remuneracoesPreenchidas[i].competencia.split('-')[1]))) {
        aux.push(remuneracoesPreenchidas[i]);
      }
    }

    for (var i = 0; i < aux.length; i++) {
        if (aux[i].valor !== aux[0].valor) {
          houveAlteracaoDeMoedaNoPeriodo = true;
          novoValorRemuneracao = aux[i].valor;
          break;
        }
      // }
    }

    if (houveAlteracaoDeMoedaNoPeriodo) {
      this.setState({
        alertas: [msgConfirmacaoCtc.periodoPossuiAlteracaoDeMoeda],
        showModalAlerta: !this.state.showModalAlerta,
        showModalAlertaValoresDiferentes: !this.state.showModalAlertaValoresDiferentes,
        houveAlteracaoDeMoedaNoPeriodo: true,
        valorRemuneracaoAlterado: novoValorRemuneracao,
      });
    } else {
      this.preencherValoresAutomaticamente();
    }
  }

  preencherValoresAutomaticamente = () => {
    const { anoEscolhido, valorRemuneracaoAlterado, listaCompetenciasPorAno }  = { ...this.state };
    let { remuneracoesPreenchidas } = { ...this.props};
    let valorPreenchimentoAutomatico = 0;
    let nenhumValorInformado = false;
    if (valorRemuneracaoAlterado !== null) {
      valorPreenchimentoAutomatico = valorRemuneracaoAlterado;
    } else {
      for (var i = 0; i < listaCompetenciasPorAno.length; i++) {
        var item = listaCompetenciasPorAno[i];
        if (anoEscolhido === (Number(item.split('-')[1]))) {
          if (document.getElementById(item).value.trim() !== '') {
            valorPreenchimentoAutomatico = document.getElementById(item).value;
            break;
          } else {
            nenhumValorInformado = true;
          }
        }
      }
    }
    if(nenhumValorInformado) {
      trataMensagensErro(['Nenhum valor informado para preenchimento automático.']);
      this.handleFechamentoModalAlerta();
    } else {
      if (anoEscolhido) {
      // inicio do preenchimento automatico por ano
        listaCompetenciasPorAno.forEach((item) => {
          if (anoEscolhido === (Number(item.split('-')[1]))) {
            let competenciaPreenchida = competenciaPreenchida = {competencia: item, valor: valorPreenchimentoAutomatico};
            const index = remuneracoesPreenchidas.findIndex(r => (r.competencia === item ));
            if (index !== -1) {
              remuneracoesPreenchidas.splice(index, 1);
            }
            if(item.indexOf('-') !== -1) {
              const index = remuneracoesPreenchidas.findIndex(r => (r.competencia === item ));
              if (index === -1) {
                remuneracoesPreenchidas.push(competenciaPreenchida);
              }
            }
          }
        });
      }
      this.props.preencherColecaoAutomaticamente({ value: remuneracoesPreenchidas, isValid: true }, 'remuneracoesPreenchidas');
      this.handleFechamentoModalAlerta();
      this.setState({
        valorRemuneracaoAlterado: null,
      });
    }

  }

  limparValoresAutomaticamente = () => {
    const { anoEscolhido, listaCompetenciasPorAno }  = { ...this.state };
    let { remuneracoesPreenchidas } = { ...this.props};
    let valorPreenchimentoAutomatico = 0;
    for (var i = 0; i < listaCompetenciasPorAno.length; i++) {
      var item = listaCompetenciasPorAno[i];
      if (anoEscolhido === (Number(item.split('-')[1]))) {
        if (document.getElementById(item).value.trim() !== '') {
          valorPreenchimentoAutomatico = '';
          break;
        }
      }
    }

    if (anoEscolhido) {
      // inicio da limpeza automatica por ano
      // for (let i = anoInicio; i <= anoFim; i += 1) {
        listaCompetenciasPorAno.forEach((item) => {
          if (anoEscolhido === (Number(item.split('-')[1]))) {
            let competenciaPreenchida = competenciaPreenchida = {competencia: item, valor: valorPreenchimentoAutomatico};
            // let competenciaPreenchida = {competencia: item, valor: valorPreenchimentoAutomatico};
            const index = remuneracoesPreenchidas.findIndex(r => (r.competencia === item ));
            if (index !== -1) {
              remuneracoesPreenchidas.splice(index, 1);
            }
          }
        });
      }
    // preenche os valores com ''
    this.props.preencherColecaoAutomaticamente({ value: remuneracoesPreenchidas, isValid: true }, 'remuneracoesPreenchidas');
    this.handleFechamentoModalAlerta();
    this.setState({
      valorRemuneracaoAlterado: null,
    });
  }

  verificarHabilitacaoBotaoLimpeza = (ano, remuneracoesPreenchidas) => {
    // const { listaCompetenciasPorAno }  = { ...this.state };
    // let { remuneracoesPreenchidas } = { ...this.props};
    // let valorPreenchimentoAutomatico = 0;
    let habilitarBotao = false;

    for (var i = 0; i < remuneracoesPreenchidas.length; i++) {
      var item = remuneracoesPreenchidas[i];
      if (ano === (Number(item.competencia.split('-')[1]))) {
        if (item.competencia.trim() !== '') {
          habilitarBotao = true;
          break;
        }
      }
    }
    return habilitarBotao;
  }

  criarFormularioPreenchimentoAutomatico = () => {
    const preenchimentoAutomatico = (
      <div>
        <DtpContentContainer>
          <Grid cols="2 2 2 2">
            <Input
              label="Valor"
              onChange={e => this.handleChange(e, 'valorPreenchimentoAutomatico')}
              value={this.state.valorPreenchimentoAutomatico}
              currency
              maxlength="16"
            />
          </Grid>
          <Grid cols="2 2 2 2">
            <Input
              label="Período selecionado"
              value={this.state.idTabSelecionada}
              disabled
            />
          </Grid>
        </DtpContentContainer>
      </div>
    );
    return preenchimentoAutomatico;
  }

  verificarCriacaoCombobox = () => {
    let retorno = false;
    const { totalizadorAnos } = { ...this.props.remuneracoesAtividade }
    const ano = listUtils.anosPorAba[0].value;
    if (totalizadorAnos > ano) {
      retorno = true;
    }
    return retorno;
  }

  criarComboBoxQtdAnosPorTab = () => {
    const comboBox = (
      <React.Fragment>
        <div className='row'
          style={{ align: 'left' }}
        >
          <Grid cols="3 3 3 3">
            <Input
              label="Anos por aba"
              onChange={e => this.handleChangeQuantidadeAnosPorAbas(e, 'quantidadeAnosPorTabs')}
              value={this.state.quantidadeAnosPorTabs}
              itemList={listUtils.anosPorAba}
            />
          </Grid>
        </div>
      </React.Fragment>
    );
    return comboBox;
  }

  montarTabsDinamicas = () => {
    const listaTabs = [];
    let { quantidadeAnosPorTabs } = { ...this.state };
    const listaAnos = this.props.remuneracoesAtividade.anos;
    const qtdAnosAtividade = this.props.remuneracoesAtividade.totalizadorAnos;
    let titulo = '';
    let idTab = null;
    let qtdAnosRestantes = qtdAnosAtividade;

    // Inicio da primeira tab
    titulo = this.montarTituloTab(listaAnos, 0, quantidadeAnosPorTabs);
    idTab = this.montarIdTab(listaAnos, 0, quantidadeAnosPorTabs);
    qtdAnosRestantes = Number(qtdAnosRestantes - quantidadeAnosPorTabs);
    listaTabs.push(this.criarTab(titulo, idTab, true));
    // A primeira tab fica ativa por padrao.
    // Fim da primeira tab

    for (let index = (quantidadeAnosPorTabs + 1); index <= qtdAnosAtividade; index += quantidadeAnosPorTabs) {
      let indiceFim = ((quantidadeAnosPorTabs + index) - 1);
      const ultimoIndiceDaLista = listaAnos.length -1;
      if (indiceFim > ultimoIndiceDaLista) {
        indiceFim = ultimoIndiceDaLista;
      }
      if (qtdAnosRestantes >= quantidadeAnosPorTabs) {
        titulo = this.montarTituloTab(listaAnos, index, indiceFim);
        idTab = this.montarIdTab(listaAnos, index, indiceFim);
        qtdAnosRestantes = Number(qtdAnosRestantes - quantidadeAnosPorTabs);
        listaTabs.push(this.criarTab(titulo, idTab, false));
      } else {
        if (index <= indiceFim) {
          titulo = this.montarTituloTab(listaAnos, index, indiceFim);
          idTab = this.montarIdTab(listaAnos, index, indiceFim);
          listaTabs.push(this.criarTab(titulo, idTab, false));
        }
      }
    }
    return listaTabs;
  }

  montarCorpoRemuneracoes = () => {
    const corpo = (
      <DtpTabGroup className="dtp-default">
        {this.montarTabsDinamicas()}
      </DtpTabGroup>
    );
    return corpo;
  }

  handleFechamentoModalAlerta = () => {
    this.setState({
      chaveConfirmacao: null,
      alertas: [],
      showModalAlerta: false,
      showModalAlertaValoresDiferentes: false,
      showModalAlertaLimpezaAutomatica: false,
    });
  }

  render() {
    let modalAlerta;
    if (this.state.showModalAlerta) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.verificarExistenciaDeMudancaDeMoedaNaCompetencia}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
        tamanho='md'
      />);
    }
    if (this.state.showModalAlertaValoresDiferentes) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.preencherValoresAutomaticamente}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
        tamanho='md'
      />);
    }
    if (this.state.showModalAlertaLimpezaAutomatica) {
      modalAlerta = (<ModalAlerta
        alertas={this.state.alertas}
        aceitar={this.limparValoresAutomaticamente}
        handleModal={this.handleFechamentoModalAlerta}
        showModal
        tamanho='md'
      />);
    }
    const retorno = (
      <DtpContentContainer>
        {this.verificarCriacaoCombobox() ? this.criarComboBoxQtdAnosPorTab() : ''}
        {this.montarCorpoRemuneracoes()}
        {modalAlerta}
      </DtpContentContainer>
    );
    return retorno;
  }
}

RemuneracaoControl.propTypes = {
  remuneracoesAtividade: PropTypes.objectOf(PropTypes.object).isRequired,
  handleChange: PropTypes.func.isRequired,
  atualizarListaRemuneracao: PropTypes.func.isRequired,
  preencherColecaoAutomaticamente: PropTypes.func.isRequired,
  remuneracoesPreenchidas: PropTypes.arrayOf(PropTypes.shape({
    competencia: PropTypes.string,
    valor: PropTypes.string,
  })).isRequired,
  desabilitarCampos: PropTypes.bool.isRequired,
  operacaoRemuneracao: PropTypes.number.isRequired,
  anoEscolhido: PropTypes.number.isRequired,
  acao: PropTypes.string,
};

export default RemuneracaoControl;



// WEBPACK FOOTER //
// ./src/pages/repositorio-ctc/templates/RemuneracaoControl.jsx